import { FC, ReactNode, Suspense } from 'react';
import { ErrorBoundary } from './RootErrorBoundary';
import { GenericErrorMessage } from '../GenericErrorMessage/GenericErrorMessage';

const ErrorBoundaryWithSuspense: FC<{
  fallbackOrSkeleton: ReactNode;
  children: ReactNode;
}> = ({ fallbackOrSkeleton, children }) => {
  return (
    <Suspense fallback={fallbackOrSkeleton}>
      <ErrorBoundary fallback={<GenericErrorMessage />}>
        {children}
      </ErrorBoundary>
    </Suspense>
  );
};

export { ErrorBoundaryWithSuspense };
